"use client";
import { FellouButton } from "@/ui-components-next/FellouButton";
import classNames from "classnames";
import Image from "next/image";
import Link from "next/link";
import { useRouter, usePathname } from "next/navigation";
import { useEffect, useMemo, useState, useCallback, useContext } from "react";
import { menuList } from "./customerList";
import { handleScroll, onLogin, logout } from "@/utils";
import { ScrollTypeEnum } from "@/components/CommonLayout/constants";
import { Popover } from "antd";
import { WebsiteContext, WebsiteContextKey } from "@/components/CommonLayout/WebsiteContext";
import "./styles.scss";

export default function Header() {
  const router = useRouter();
  const pathname = usePathname();
  const [isAtTop, setIsAtTop] = useState(true);
  const [userInfo, setUserInfo] = useState<{ picture: string } | null>(null);
  const [popoverOpen, setPopoverOpen] = useState(false);
  const { onSaveWebsiteCallback } = useContext(WebsiteContext);
  const getUserInfo = useCallback(async () => {
    const userInfo = localStorage.getItem("fellou.userInfo");
    if (userInfo) {
      setUserInfo(JSON.parse(userInfo));
    }
  }, []);

  useEffect(() => {
    getUserInfo();
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined") {
      setIsAtTop(window.scrollY === 0);
      const handleScroll = () => {
        setIsAtTop(window.scrollY === 0);
      };

      window.addEventListener("scroll", handleScroll);
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }
  }, []);

  const homeClass = useMemo(() => {
    return classNames({
      header: true,
      "header-background": !isAtTop,
    });
  }, [isAtTop]);

  useEffect(() => {
    const handleLoginSuccess = (e: CustomEvent) => {
      if (e.detail) {
        getUserInfo();
      }
    };
    window.addEventListener("login_success", handleLoginSuccess as EventListener);
    return () => {
      window.removeEventListener("login_success", handleLoginSuccess as EventListener);
    };
  }, []);

  return (
    <div className={"fellou-pc-header-display"}>
      <header className={homeClass}>
        <Link href="/">
          <div className={"fellou-logo relative"}>
            <Image
              src="/logo.svg"
              alt="fellou"
              fill
              priority
              unoptimized
            />
          </div>
        </Link>
        <div className={"header-menu"}>
          {menuList.map((item, index) => {
            const isCurrentPage = pathname === item.href;
            return (
              <Link
                href={item.href}
                key={`menu-item-${index}`}
                target={
                  item.href === "/" || item.href === "/use-cases/" || item.href === "/pricing/" ? undefined : "_blank"
                }
              >
                <div
                  className={classNames("menu-item cursor-pointer", {
                    active: isCurrentPage,
                  })}
                >
                  {item.title}
                </div>
              </Link>
            );
          })}
        </div>
        <div className={"header-login"}>
          {["pricing", "account"].some((path) => pathname.includes(path)) ? (
            // 如果是pricing页面，显示登录逻辑
            <>
              {!userInfo ? (
                <FellouButton
                  mode="white-graybg"
                  className="home-header-btn"
                  style={{
                    fontWeight: 400,
                  }}
                  onClick={() => {
                    onLogin();
                  }}
                >
                  Log in
                </FellouButton>
              ) : (
                <>
                  <Popover
                    getPopupContainer={() => document.querySelector(".header-login") as HTMLElement}
                    // open={true}
                    open={popoverOpen}
                    placement="bottomRight"
                    arrow={false}
                    content={
                      <div className="user-popover-content">
                        <div className="user-actions-item">
                          <button
                            className="logout-btn"
                            onClick={() => {
                              setPopoverOpen(false);
                              router.push("/account");
                            }}
                          >
                            <i className="icon iconfont icon-user_4_line"></i>
                            Account
                          </button>
                        </div>
                        <div
                          className="user-actions-item"
                          onClick={() => {
                            setPopoverOpen(false);
                            logout();
                          }}
                        >
                          <button className="logout-btn">
                            <i className="icon iconfont icon-logout-circle-line"></i>
                            Sign Out
                          </button>
                        </div>
                      </div>
                    }
                    onOpenChange={setPopoverOpen}
                    overlayClassName="custom-popover"
                  >
                    <div className="header-user-info-avatar" onClick={() => setPopoverOpen(!popoverOpen)}>
                      <Image src={userInfo.picture} alt="fellou" fill unoptimized priority />
                    </div>
                  </Popover>
                </>
              )}
            </>
          ) : (
            <></>
          )}
        </div>
      </header>
    </div>
  );
}
